export default __webpack_public_path__ + "static/media/pharmacy.6a6549bd.png";